import styled from 'styled-components';
import { rgba } from 'polished';

import { FlexContainer } from '@legacy/moon/Layout';
import { BodySmall, TinyText } from '@legacy/moon/particles/Typography';
import colors from '@legacy/moon/particles/colors';

const GraphContainer = styled.div`
  position: relative;
  height: inherit;
  width: 100%;
  display: inline-flex;
  justify-content: center;
`;

const TooltipContainer = styled(FlexContainer)`
  flex-flow: column wrap;
  background-color: ${colors.moonlight0};
  padding: 0.5rem 1rem;
  box-shadow: 0px 0px 16px ${rgba(colors.moonlight40, 0.3)};
`;

const ValueText = styled(BodySmall)`
  color: ${colors.moonlight90};
  margin-bottom: 0;
`;

const LabelText = styled(TinyText)`
  color: ${colors.moonlight60};
`;

export { TooltipContainer, GraphContainer, ValueText, LabelText };
